import React from 'react';













//const viewQuery ="SELECT ID,name,class FROM school ";
 class AllAttachments extends React.Component {
   
    constructor(props) {
        super(props);

      
        this.state = {
            viewdata:[],

        };
      }








 componentDidMount() {

}

componentWillUnmount(){

}





  render(){
  const AttachmentsView =this.state.viewdata.map(attach =><div key={attach.attachid}><a  href={`http://50.50.50.50/attachmentbyname/${attach.attachment}`}>{attach.attachment}</a></div>
  )






  return (
<div>
<strong>Attachments</strong>
{AttachmentsView}

</div>

  );
}
}
export default AllAttachments;
